import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StatCard = ({ label, children, className = "", }) => {
    return (_jsxs("div", { className: `rounded-lg bg-gray-100 p-4 text-center dark:bg-gray-800 ${className}`, children: [_jsx("div", { className: "mb-1 text-sm text-gray-600 dark:text-gray-400", children: label }), _jsx("div", { className: "flex items-baseline justify-center gap-2", children: children })] }));
};
export default StatCard;
